/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum FluiditeTauxOccupationValues {
  Na = 'NA',
  Eleve = 'Eleve',
  Moyen = 'Moyen',
  Faible = 'Faible',
}
